export default __webpack_public_path__ + "static/media/five.bbe897fb.jpeg";